/* =========================================================
   MASSILIA PREMIUM 2026 — JS GLOBAL (Stable)
   ✅ FAQ verrouillée (1 ouverte à la fois)
   ✅ Fix mobile "couloir" Speedfly (anti clipping)
   ✅ Restauration automatique sur desktop
========================================================= */
(function () {
  var KEY = "__mdp2026_prev__";
  var RESIZE_T = null;

  /* ---------- FAQ verrouillée ---------- */
  function lockFaq(root){
    var faq = root.querySelector(".md-faq");
    if(!faq) return;
    var items = faq.querySelectorAll("details");
    items.forEach(function(d){
      d.open = false;
      d.addEventListener("toggle", function(){
        if(d.open){
          items.forEach(function(other){
            if(other !== d) other.open = false;
          });
        }
      });
    });
  }

  /* ---------- Parents helper ---------- */
  function getParents(el, max){
    var out = [];
    var p = el && el.parentElement;
    var i = 0;
    while(p && i < (max || 10)){
      out.push(p);
      p = p.parentElement;
      i++;
    }
    return out;
  }

  /* ---------- Mobile unclamp + desktop restore ---------- */
  function applyMobileFix(parents){
    parents.forEach(function(p){
      // Sauvegarde 1 fois l’état inline existant
      if(!p[KEY]){
        p[KEY] = {
          overflow: p.style.overflow || "",
          maxWidth: p.style.maxWidth || "",
          width: p.style.width || "",
          paddingLeft: p.style.paddingLeft || "",
          paddingRight: p.style.paddingRight || ""
        };
      }
      // Patch mobile : empêche le "clipping" du conteneur onglets
      p.style.overflow = "visible";
      p.style.maxWidth = "100%";
      p.style.width = "100%";
      p.style.paddingLeft = "0";
      p.style.paddingRight = "0";
    });
  }

  function restoreDesktop(parents){
    parents.forEach(function(p){
      var prev = p[KEY];
      if(!prev) return;
      // Restaure exactement l’état initial
      p.style.overflow = prev.overflow;
      p.style.maxWidth = prev.maxWidth;
      p.style.width = prev.width;
      p.style.paddingLeft = prev.paddingLeft;
      p.style.paddingRight = prev.paddingRight;
    });
  }

  function run(){
    // 1) FAQ
    document.querySelectorAll("#md-product").forEach(lockFaq);

    // 2) Fix "couloir" sur mobile
    var el = document.getElementById("md-product");
    if(!el) return;

    var parents = getParents(el, 10);
    if(window.innerWidth <= 960){
      applyMobileFix(parents);
    } else {
      restoreDesktop(parents);
    }
  }

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("resize", function(){
    clearTimeout(RESIZE_T);
    RESIZE_T = setTimeout(run, 120);
  });
})();

document.addEventListener("DOMContentLoaded", function () {

  var faqs = document.querySelectorAll(".mdp-faq, .md-faq");

  faqs.forEach(function (faq) {

    var items = faq.querySelectorAll("details");

    items.forEach(function (d) {

      // Fermé par défaut
      d.open = false;

      // Ajout animation douce
      var content = d.querySelector("p, div");
      if (content) {
        content.style.overflow = "hidden";
        content.style.transition = "all 0.3s ease";
      }

      d.addEventListener("toggle", function () {

        if (d.open) {

          // Ferme les autres
          items.forEach(function (other) {
            if (other !== d) {
              other.open = false;
            }
          });

          // Scroll automatique
          setTimeout(function () {
            d.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }, 100);

        }

      });

    });

    // 🔗 Ouverture automatique via URL (#faq1 etc)
    if (window.location.hash) {
      var target = faq.querySelector(window.location.hash);
      if (target && target.tagName === "DETAILS") {
        target.open = true;
        setTimeout(function () {
          target.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 200);
      }
    }

  });

});;